import { Show, useShowController } from "react-admin";

import BackButtonToolbar from "features/BackButtonToolbar";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import SpecialistCurriculumItemSection from "./SpecialistCurriculumItemSection";
import SpecialistInfoSection from "./SpecialistInfoSection";
import SpecializationInfoSection from "./SpecializationInfoSection";
import SpecialistGraduationInfoSection from "./SpecialistGraduationInfoSection";
import { SpecialistStatuses } from "utils/constants";
import AssignExamCommitionDialog from "./Partials/AssignExamCommitionDialog";
import ExamCommiteeSection from "./ExamCommiteeSection";

const ShowSpecialist = () => {
  const { record } = useShowController();
  return (
    <Show
      title="Детайли за специализант"
      actions={
        <BackButtonToolbar
          additionalButton={
            record?.statusId === SpecialistStatuses.EligibleForGraduation && (
              <SecuredComponent permission={permissions.canMakeSpecialistsGraduating}>
                <AssignExamCommitionDialog specialistId={record?.id} />
              </SecuredComponent>
            )
          }
        />
      }
    >
      <SpecialistInfoSection />
      <SpecializationInfoSection statusId={record?.statusId} />
      <SpecialistGraduationInfoSection />
      <SecuredComponent permission={permissions.canPreviewSpecialistsCurriculumItems}>
        <SpecialistCurriculumItemSection
          specialistId={record?.id}
          isTrainingBuildingExternal={record?.isTrainingBuildingExternal}
          statusId={record?.statusId}
        />
      </SecuredComponent>
      {record?.statusId === SpecialistStatuses.Graduating && record?.examCommitteeId && (
        <SecuredComponent permission={permissions.canPreviewSpecialistsExamCommittees}>
          <ExamCommiteeSection examCommitteeId={record?.examCommitteeId} />
        </SecuredComponent>
      )}
    </Show>
  );
};

export default ShowSpecialist;
